<template>
  <div class="wrapper background-primary">
    <content-header></content-header>

    <div class="content" style="margin-top: -20vh">
      <div class="container-fluid">
        <div
          class="row flex-row flex-nowrap justify-content-center"
          style="overflow-x: hidden"
        >
          <!-- Left Side Card 
          <div class="card shadow customs-card mx-2">
            <div class="card-header border-0 py-2 mt-4 background-card">
              <p class="text-center mb-0 font-weight-bold headline text-white">
                |
              </p>
            </div>
          </div>-->

          <!-- Content Card -->
          <div class="card shadow customs-card mx-2">
            <!-- Campaign Ended Label -->
            <div class="card-header border-0 py-2 mt-4 background-cautions">
              <p class="text-center mb-0 font-weight-bold headline text-color">
                エラーが発生しました
              </p>
            </div>

            <div
              class="card-body p-5 d-flex align-items-center justify-content-center"
            >
              <!-- Campaign Image -->
              <div class="row">
                <div class="col-6 p-0 mx-auto">
                  <img
                    src="@/assets/img/campaign/error.png"
                    alt="Campaign Ended"
                    class="img-fluid mx-auto d-block mh-100"
                  />
                </div>
              </div>
            </div>

            <div class="card-footer border-0 mb-4 background-transparent">
              <p class="text-center text text-color mb-0">
                {{ displayErrorMessage() }}
              </p>

              <!-- Campaign Button -->
              <div class="mt-4" v-if="id">
                <button
                  type="button"
                  class="btn btn-block btn-outline-dark text-color rounded-pill"
                  @click="backToTop()"
                >
                  <p class="m-0 font-weight-bold text-bold text-color">
                    TOPに戻る
                  </p>
                </button>
              </div>
            </div>
          </div>

          <!-- Right Side Card 
          <div class="card shadow customs-card mx-2">
            <div class="card-header border-0 py-2 mt-4 background-card">
              <p class="text-center mb-0 font-weight-bold headline text-white">
                |
              </p>
            </div>
          </div>-->
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import ContentHeader from "@/layout/dashboard/ContentHeader.vue";
import ContentFooter from "@/layout/dashboard/ContentFooter.vue";

import { getCampaignId } from "@/utils/campaign";
import { getErrorMessage, removeErrorMessage } from "@/utils/error";

export default {
  data() {
    return {
      id: getCampaignId(),
      error: 0,
    };
  },
  components: {
    ContentHeader,
    ContentFooter,
  },
  mounted() {
    if (getErrorMessage()) {
      this.error = parseInt(getErrorMessage());
      removeErrorMessage();
    }

    if (this.$route.path === "/not-permission") {
      this.error = 403;
    } else if (this.$route.path !== "/error") {
      this.error = 404;
    }
  },
  methods: {
    backToTop() {
      if (this.id) {
        this.$router.push("/campaign?id=" + this.id);
      }
    },
    displayErrorMessage() {
      switch (this.error) {
        case 403:
          return "アクセスしようとしたページは表示できません。";
        case 404:
          return "ページが見つかりませんでした。";
        case 500:
          return "申し訳ございません。システムエラーが発生しました。";
        case 503:
          return "ただいま、アクセスが集中しています。時間をおいてアクセスし直してください。";
        case 429:
          return "5分程度、時間をおいて再度挑戦してください。";
        default:
          return "申し訳ございません。予期せぬエラーが発生しました。";
      }
    },
  },
};
</script>
